/**
 * Nova's own screens and layouts, registered exactly the way a plugin
 * registers its own (see core/plugins.ts). Nothing here is special-cased: a
 * plugin can add a view beside Songs or a layout beside Pro the same way.
 * Radio is a plugin bundled with Nova (plugins/radio), on only when chosen.
 */

import { CompactLayout } from "../layouts/CompactLayout";
import { ProLayout } from "../layouts/ProLayout";
import { AlbumsView, ArtistsView, FoldersView, GenresView } from "../views/BrowseViews";
import { FlowView } from "../views/FlowView";
import { FlowStatus } from "../flow/FlowStatus";
import { UpdateStatusItem } from "../shell/UpdateProgress";
import { SongsView } from "../views/SongsView";
import { PluginsView } from "../views/ToolViews";
import { TagEditorView } from "../views/TagEditorView";
import { NeedsEditView } from "../views/NeedsEditView";
import { ClipsView } from "../clips/ClipsView";
import { flaggedCount } from "./needsEdit";
import { registry } from "./registry";

let done = false;

export function registerBuiltins() {
  if (done) return;
  done = true;
  const core = "core";
  registry.addLayout({ id: "compact", label: "Compact", order: 1, description: "A small player window: now playing, controls and one list.", render: () => <CompactLayout /> }, core);
  registry.addLayout({ id: "pro", label: "Pro", order: 2, description: "The full library: sidebar, song list, details, transport.", render: () => <ProLayout /> }, core);

  registry.addView({ id: "songs", label: "Songs", icon: "music", section: "library", order: 1, render: () => <SongsView /> }, core);
  registry.addView({ id: "albums", label: "Albums", icon: "disc", section: "library", order: 2, render: () => <AlbumsView /> }, core);
  registry.addView({ id: "artists", label: "Artists", icon: "user", section: "library", order: 3, render: () => <ArtistsView /> }, core);
  registry.addView({ id: "genres", label: "Genres", icon: "tag", section: "library", order: 4, render: () => <GenresView /> }, core);
  registry.addView({ id: "folders", label: "Folders", icon: "folder", section: "library", order: 5, render: () => <FoldersView /> }, core);
  registry.addView({ id: "needs-edit", label: "Needs edit", icon: "bell", section: "library", order: 6, badge: () => (flaggedCount() ? String(flaggedCount()) : null), render: () => <NeedsEditView /> }, core);
  registry.addView({ id: "clips", label: "Clips", icon: "layers", section: "library", order: 7, ownPanel: true, permission: "clips.edit", render: () => <ClipsView /> }, core);

  registry.addStatusItem({ id: "flow", side: "left", order: 1, render: () => <FlowStatus /> }, core);
  registry.addStatusItem({ id: "update", side: "right", order: 0, render: () => <UpdateStatusItem /> }, core);
  registry.addView({ id: "flow", label: "Flow", icon: "wave", section: "discover", order: 1, badge: () => "mix", permission: "flows.use", render: () => <FlowView /> }, core);
  registry.addView({ id: "studio", label: "Tag editor", icon: "edit", section: "discover", order: 3, permission: "library.edit", render: () => <TagEditorView /> }, core);

  registry.addView({ id: "plugins", label: "Plugin manager", icon: "plug", section: "hidden", permission: "plugins.manage", render: () => <PluginsView /> }, core);
}
